import React, { useState, useEffect } from 'react';
import * as R from 'ramda';
import { composePS } from '@cd/pipe';
import { useHistory } from 'react-router';
import styles from '../css/Register.module.scss';
import { postJSONPS } from '../../lib/utils/fetch';
import { either } from '../../lib/utils/utils';
import Form from '../../dynamic/components/form/components/Form';

import { REGISTER_FORM } from '../../lib/utils/formFields';
import { useForm } from '../../dynamic/components/form/components/formUtils';
import withAlert from './withAlert';
import { postGetStaticInfo, postGetServerVar } from '../../postGetStatic';
import CenterProgress from '../../CenterProgress';

const postGetRegistrationInfo = () =>
	composePS(postJSONPS)('POST', `/getRegistationInfo`, {
		body: JSON.stringify({})
	});

const postSetAccountInfo = data =>
	composePS(postJSONPS)('POST', `/setRegistationInfo`, {
		body: JSON.stringify({ data })
	});

// Inner form. Mounted only once `schema` is resolved, so useForm receives the
// real (dynamically built) schema — mirrors the original branch-before-withForm
// ordering.
const RegisterForm = ({ schema, history, onOpenAlertDlg }) => {
	const {
		data,
		onUpdateData,
		showPassword,
		onShowPassword,
		onSave: formOnSave,
		touched,
		validation,
		preProcessData,
		updateInitData
	} = useForm({ schema });
	const [registrationText, setRegistrationText] = useState('');

	useEffect(() => {
		composePS(updateInitData, preProcessData, postGetRegistrationInfo)();

		postGetStaticInfo('registrationMsg').then(
			either(console.log, t => setRegistrationText(t))
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onBackToLogin = () => {
		history.push('/login');
	};

	const onSave = () => {
		postSetAccountInfo(data).then(
			either(
				e =>
					onOpenAlertDlg({
						message: R.is(String, e) ? e : JSON.stringify(e),
						title: 'Error'
					}),
				message => {
					formOnSave();
					onOpenAlertDlg({
						message,
						title: 'Success',
						okCallback: () => {
							history.push('/login');
						}
					});
				}
			)
		);
	};

	if (!registrationText) {
		return <CenterProgress />;
	}

	return (
		<div className={styles.wrap}>
			<div className={styles.registerText}>{registrationText}</div>
			<Form
				formTitle="REGISTER FOR eLocal"
				formFields={schema}
				comboBoxData={{ states: [] }}
				data={data}
				onUpdateData={onUpdateData}
				showPassword={showPassword}
				onShowPassword={onShowPassword}
				onSave={onSave}
				onCancel={onBackToLogin}
				validation={validation}
				editing={true}
				touched={touched}
				buttonLabels={['REGISTER', 'LOGIN']}
				buttonIcons={['save', 'keyboard_backspace']}
			/>
		</div>
	);
};

const Register = withAlert(({ onOpenAlertDlg }) => {
	const history = useHistory();
	const [schema, setSchema] = useState(null);

	useEffect(() => {
		postGetServerVar('registrationNoBookNo').then(
			either(console.log, omitBookNo => {
				const formSchema = omitBookNo
					? R.reject(R.propEq('name', 'bookNo'), REGISTER_FORM)
					: REGISTER_FORM;

				postGetServerVar('registrationAccessCodeMsg').then(
					either(console.log, accessCodeMsg => {
						if (accessCodeMsg && accessCodeMsg.length > 0) {
							const index = formSchema.findIndex(
								R.propEq('name', 'accessCode')
							);
							formSchema[index].helperText = accessCodeMsg;
						}
						setSchema(formSchema);
					})
				);
			})
		);
	}, []);

	if (schema === null) {
		return <CenterProgress />;
	}

	return (
		<RegisterForm
			schema={schema}
			history={history}
			onOpenAlertDlg={onOpenAlertDlg}
		/>
	);
});

export default Register;
